import { BillingInterval, Plan } from "@/types";

/**
 * Because `planStack.plans` has both yearly and monthly variants of the same plan
 * filters by interval so we don't show duplicates
 */
export const filterPlansByInterval = (isAnnual: boolean, plans: Plan[]) => {
  const selectedInterval = isAnnual
    ? BillingInterval.year
    : BillingInterval.month;

  return plans.filter((p) => p.interval === selectedInterval);
};
